/* Pés Felizes — entrega estimada (hora de Lisboa) + tooltip da morada da loja.
   Regras (definidas nas definições do bloco, em data-*):
   - Encomenda feita num dia COM recolha e antes da hora limite -> segue nesse dia.
   - Caso contrário segue no próximo dia com recolha.
   - Entrega = envio + N dias de entrega (dias marcados no bloco, sem datas excluídas), entre o mínimo e o máximo. */
(() => {
  if (customElements.get('pf-delivery-estimate')) return;

  const TZ = 'Europe/Lisbon';
  const DAYS = ['domingo', 'segunda', 'terça', 'quarta', 'quinta', 'sexta', 'sábado'];
  const MONTHS = ['jan', 'fev', 'mar', 'abr', 'mai', 'jun', 'jul', 'ago', 'set', 'out', 'nov', 'dez'];
  const DAY_MS = 86400000;

  const lisbonNow = () => {
    const parts = new Intl.DateTimeFormat('en-GB', {
      timeZone: TZ, year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', hourCycle: 'h23',
    }).formatToParts(new Date());
    const get = (t) => Number(parts.find((p) => p.type === t).value);
    // Data de calendário em UTC ao meio-dia, para a aritmética de dias não sofrer com mudanças de hora.
    return { date: new Date(Date.UTC(get('year'), get('month') - 1, get('day'), 12)), hour: get('hour') };
  };

  const key = (d) => d.toISOString().slice(0, 10);
  const addDays = (d, n) => new Date(d.getTime() + n * DAY_MS);
  const fmt = (d) => `${DAYS[d.getUTCDay()]}, ${d.getUTCDate()} ${MONTHS[d.getUTCMonth()]}`;

  class PfDeliveryEstimate extends HTMLElement {
    connectedCallback() {
      this.render();
    }

    render() {
      const num = (v, f) => (Number.isFinite(Number(v)) && v !== '' ? Number(v) : f);
      const cutoff = num(this.dataset.cutoff, 15);
      const pickupDays = new Set((this.dataset.pickupDays || '').split(',').filter(Boolean).map(Number));
      const deliveryDays = new Set((this.dataset.deliveryDays || '1,2,3,4,5').split(',').filter(Boolean).map(Number));
      const min = num(this.dataset.min, 1);
      const max = Math.max(min, num(this.dataset.max, 3));
      const off = new Set((this.dataset.holidays || '').split(/[\s,;]+/).filter((s) => /^\d{4}-\d{2}-\d{2}$/.test(s)));
      const dates = this.querySelector('[data-ref="dates"]');
      if (!pickupDays.size || !dates) return;

      const isBusiness = (d) => deliveryDays.has(d.getUTCDay()) && !off.has(key(d));
      const isPickup = (d) => pickupDays.has(d.getUTCDay()) && !off.has(key(d));

      const { date: today, hour } = lisbonNow();
      let dispatch = today;
      if (!(isPickup(today) && hour < cutoff)) {
        dispatch = addDays(today, 1);
        for (let i = 0; i < 60 && !isPickup(dispatch); i++) dispatch = addDays(dispatch, 1);
      }

      const plusBusiness = (from, n) => {
        let d = from;
        let left = n;
        for (let i = 0; i < 90; i++) {
          if (left === 0 && isBusiness(d)) return d;
          d = addDays(d, 1);
          if (isBusiness(d)) left = Math.max(0, left - 1);
          if (left === 0 && isBusiness(d)) return d;
        }
        return d;
      };

      const from = plusBusiness(dispatch, min);
      const to = plusBusiness(dispatch, max);
      dates.textContent = key(from) === key(to) ? fmt(from) : `${fmt(from)} e ${fmt(to)}`;
      this.hidden = false;
    }
  }
  customElements.define('pf-delivery-estimate', PfDeliveryEstimate);

  // Tooltip da morada: hover/foco por CSS; toque/clique alterna.
  document.addEventListener('click', (e) => {
    const btn = e.target.closest?.('.pf-info-box__tipbtn');
    document.querySelectorAll('.pf-info-box__tipwrap.is-open').forEach((w) => {
      if (btn && w.contains(btn)) return;
      w.classList.remove('is-open');
      w.querySelector('.pf-info-box__tipbtn')?.setAttribute('aria-expanded', 'false');
    });
    if (!btn) return;
    const wrap = btn.closest('.pf-info-box__tipwrap');
    const open = wrap.classList.toggle('is-open');
    btn.setAttribute('aria-expanded', String(open));
  });
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('.pf-info-box__tipwrap.is-open').forEach((w) => {
      w.classList.remove('is-open');
      w.querySelector('.pf-info-box__tipbtn')?.setAttribute('aria-expanded', 'false');
    });
  });
})();
